export default "__VITE_ASSET__4232844f__"